var jade = require("/Users/lest/code/presentation-template/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<section><h1>Title</h1><h2>Subtitle</h2></section><section><h2>Syntax Highlighting</h2><pre><code class=\"language-ruby\">class Foo\n  def hello(name)\n    puts \"Hello #{name}!\"\n  end\nend\n</code></pre></section><section><h2>Questions?</h2></section>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./slides.jade
 ** module id = 12
 ** module chunks = 0
 **/